import { HTMLAttributes, FC } from 'react'
import { connect } from 'react-redux'
import { StoreDispatch } from 'interfaces/component'
import { trackUIEventAction } from 'actions/analyticsActions'
import { AnalyticsEvent } from 'interfaces/analytics'

export type AnalyticsClickComponentDispatchProps = {
  trackUIEvent: (event: AnalyticsEvent) => void
}

export type AnalyticsClickComponentOwnProps =
  & AnalyticsEvent
  & HTMLAttributes<HTMLDivElement>

type AnalyticsClickComponentProps =
  & AnalyticsClickComponentDispatchProps
  & AnalyticsClickComponentOwnProps

const AnalyticsClickComponent: FC<AnalyticsClickComponentProps> = (props) => {
  const {
    children,
    trackUIEvent,
    category,
    action,
    label,
    onClick,
    ...htmlProps
  } = props

  return (
    <div
      { ...htmlProps }
      onClick={ (event) => {
        onClick && onClick(event)
        trackUIEvent({ category, action, label } as AnalyticsEvent)
      } }
    >
      { children }
    </div>
  )
}

const mapDispatchToProps = (dispatch: StoreDispatch): AnalyticsClickComponentDispatchProps => ({
  trackUIEvent: (event) => dispatch(trackUIEventAction(event)),
})

export const AnalyticsClick = connect<{}, AnalyticsClickComponentDispatchProps, AnalyticsClickComponentOwnProps>(
  undefined, mapDispatchToProps
)(AnalyticsClickComponent)

